let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6HfLM")).then(() => parcelRequire('6jUOS'));